import * as types from '../../constants/actionTypes';

const defaultState = {
  db: {},
  scheduleAppointment: {},
};

const exportReducer = (state = defaultState, action: any) => {
  switch (action.type) {
    case types.LOAD_DATA:
      return {
        ...state,
        db: action.data,
      };
    case types.LOAD_PATIENT_DASHBOARD_DATA:
      return {
        ...state,
        patientDashboard: action.data,
      };
    case types.LOAD_WAITING_ROOM_DATA:
      return {
        ...state,
        waitingRoom: action.data,
      };
    case types.LOAD_PHYSICIAN_LANDING_DATA:
      return {
        ...state,
        physicianLanding: action.data,
      };
    case types.LOAD_PHYSICIAN_INFO_DETAILS_DATA:
      return {
        ...state,
        physicianInfoDetails: action.data,
      };
    case types.LOAD_PROFILE_INFO_DATA:
      return {
        ...state,
        profileInfo: action.data,
      };
    case types.LOAD_SCHEDULE_APPOINTMENT_DATA:
      return {
        ...state,
        scheduleAppointment: action.data,
      };
    case types.LOAD_RELATION_TO_POLICY_HOLDER_DATA:
      return {
        ...state,
        relationToPolicyHolder: action.data,
      };
    case types.LOAD_CREDIT_CARD_ISSUER_DATA:
      return {
        ...state,
        creditCardIssuer: action.data,
      };
    case types.LOAD_SNEWZZZ_DATA:
      return {
        ...state,
        snewzzz: action.data,
      };
    case types.LOAD_LOADER:
      return {
        ...state,
        showLoading: action.data,
      };
    default:
      return state;
  }
};

export default exportReducer;